import { ThemeResolver } from './Resolvers/theme.resolver';
import { LandingPageComponent } from './Shared/Components/landing-page/landing-page.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PageNotFoundComponent } from './Shared/Components/page-not-found/page-not-found.component';
import { applicationPaths } from './Models/configurations';

const routes: Routes = [
  { path: '', redirectTo: '/' + applicationPaths.landing, pathMatch: 'full' },
  {
    path: applicationPaths.landing,
    component: LandingPageComponent,
    resolve: { resource: ThemeResolver },
  },
  { path: '', loadChildren: () => import('./Views/Steps/step.module').then(m => m.StepModule) },
  { path: '**', component: PageNotFoundComponent },
  // { path: applicationPaths.unauthorize, component: UnauthorizePageComponent },
  // { path: applicationPaths.confirmationfail, component: ConfirmationFailComponent },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
